import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { CircularProgress } from "@mui/material";
import Button from "components/Forms/CustomButtons/ButtonTS";
import { useTranslation } from "react-i18next";
import { useState } from "react";

interface DeleteActivityItemModalProps {
  modalOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void; // Alterado para receber o motivo
}

export default function DeleteActivityItemModal({
  modalOpen,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteActivityItemModalProps): JSX.Element {
  const { t } = useTranslation(["modals", "activity-item"]);
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(reason);
  };

  return (
    <Dialog
      open={modalOpen}
      fullWidth
      maxWidth='sm'
      scroll='body'
      onClose={onClose}
      disableBackdropClick
    >
      <DialogTitle>
        {t("delete-activity-item-title", { ns: "modals" })}
        <Button
          justIcon
          simple
          color='tumblr'
          round
          size='sm'
          style={{ position: "absolute", right: "10px", top: "10px" }}
          onClick={onClose}
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogContent>
        {t("delete-activity-item-body", { ns: "modals" })}
        <TextField
          label={t("reason", { ns: "modals" })}
          variant="outlined"
          fullWidth
          multiline
          rows={2}
          margin="normal"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
          data-cy="delete-reason-input"
        />
      </DialogContent>
      <DialogActions style={{ padding: "16px 22px" }}>
        <Button disabled={isDeleting} color='tumblr' simple onClick={onClose}>
          {t("cancel")}
        </Button>

        <Button 
          disabled={isDeleting || !reason.trim()} 
          onClick={handleConfirm} 
          color='success'
          data-cy="confirm-delete-button"
        >
          {isDeleting ? <CircularProgress size={24} /> : t("proceed")}
        </Button>
      </DialogActions>

    </Dialog>
  );
}